// 互评系统模块路由配置
export const ratingMain = [
  {
    name: 'rating',
    path: '/rating',
    meta: {
      title: '互评系统',
      icon: 'star'
    }
  },
  {
    name: 'rating_settings',
    path: '/rating/settings',
    component: () => import('/@/views/plugins/rating/settings.vue'),
    meta: {
      title: '系统设置',
      icon: 'star',
      plugin: 'rating',
      keepAlive: true
    }
  },
  {
    name: 'rating_persons',
    path: '/rating/persons',
    component: () => import('/@/views/plugins/rating/persons.vue'),
    meta: {
      title: '人员管理',
      icon: 'star',
      plugin: 'rating',
      keepAlive: true
    }
  },
  {
    name: 'rating_items',
    path: '/rating/items',
    component: () => import('/@/views/plugins/rating/items.vue'),
    meta: {
      title: '评分项管理',
      icon: 'star',
      plugin: 'rating',
      keepAlive: true
    }
  },
  {
    name: 'rating_results',
    path: '/rating/results',
    component: () => import('/@/views/plugins/rating/results.vue'),
    meta: {
      title: '评分结果',
      icon: 'star',
      plugin: 'rating',
      keepAlive: true
    }
  },
  {
    name: 'rating_details',
    path: '/rating/details',
    component: () => import('/@/views/plugins/rating/details.vue'),
    meta: {
      title: '评分明细',
      icon: 'star',
      plugin: 'rating',
      keepAlive: true
    }
  }
]

export default ratingMain
